import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { DropdownSelect } from "@whoosh/design-system/src/components/controls";
import { Text, VStack } from "@whoosh/design-system/src/components/primitive";

import { durationDisplayFromMinutesShort } from "../../../../utils/formatTime";
import { DurationFilterControlFragment_facility$key } from "./__generated__/DurationFilterControlFragment_facility.graphql";

type Props = {
  facilityRef: DurationFilterControlFragment_facility$key | null;
  selectedDuration?: number;
  onChange: (value: number) => void;
};

export const DurationFilterControl = ({
  facilityRef,
  onChange,
  selectedDuration,
}: Props) => {
  const facility = useFragment(
    DurationFilterControlFragmentString,
    facilityRef
  );

  const durationOptions =
    facility?.durations?.flatMap((d) =>
      d
        ? [
            {
              label: durationDisplayFromMinutesShort(d) || "",
              value: d,
            },
          ]
        : []
    ) || [];
  return (
    <VStack gap={4}>
      <Text variant="mainSmallSemiBold">{t`Duration`}</Text>
      <DropdownSelect<number>
        options={durationOptions}
        placeholder={t`Any`}
        onChange={onChange}
        value={selectedDuration}
        hideOuterMargin
      />
    </VStack>
  );
};

export const DurationFilterControlFragmentString = graphql`
  fragment DurationFilterControlFragment_facility on Facility {
    id
    durations
  }
`;
